<template>
  <div class="infomation-page">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-back" @click="back()">
        <van-icon name="arrow-left" />
      </div>
      <h1 class="header-title">{{ $t('my.personal_info') || '個人資訊' }}</h1>
      <div class="header-placeholder"></div>
    </header>

    <!-- 表单内容 -->
    <div class="form-container">
      <!-- 用户姓名 -->
      <div class="form-group">
        <label class="form-label">{{ $t('my.basic_information') || '用戶姓名' }}</label>
        <input
          v-model="formData.name"
          type="text"
          class="form-input"
          :placeholder="$t('setting.real_name') || '請輸入使用者姓名'"
        />
      </div>

      <!-- 使用者手機 -->
      <div class="form-group">
        <label class="form-label">{{ $t('my.contact') || '使用皮手機' }}</label>
        <input
          v-model="formData.phone"
          type="tel"
          class="form-input"
          :placeholder="$t('setting.mobile_place') || '請輸入使用者手機'"
        />
      </div>

      <!-- 信箱 -->
      <div class="form-group">
        <label class="form-label">{{ $t('setting.email') || '信箱' }}</label>
        <input
          v-model="formData.email"
          type="email"
          class="form-input"
          :placeholder="$t('setting.email_place') || '請輸入信箱'"
        />
      </div>

      <!-- 用户生日 -->
      <div class="form-group">
        <label class="form-label">{{ $t('setting.birthday') || '用户生日' }}</label>
        <input
          v-model="formData.birthday"
          type="text"
          class="form-input"
          :placeholder="$t('setting.birthday_place') || '請輸入您的生日'"
        />
      </div>

      <!-- 提交按钮 -->
      <button class="submit-btn" @click="submitForm">
        {{ $t('q18') || '提交' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        email: '',
        birthday: ''
      },
      isLoading: false
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    submitForm() {
      // 验证表单
      if (!this.formData.name) {
        this.$toast('請輸入使用者姓名');
        return;
      }
      if (!this.formData.phone) {
        this.$toast('請輸入使用者手機');
        return;
      }
      if (!this.formData.email) {
        this.$toast('請輸入信箱');
        return;
      }

      this.isLoading = true;
      this.$http({
        method: 'post',
        url: 'set_user_info',
        data: {
          name: this.formData.name,
          phone: this.formData.phone,
          email: this.formData.email,
          birthday: this.formData.birthday || null
        }
      }).then(res => {
        if (res.code === 200) {
          this.$toast('更新成功');
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        } else if (res.code === 401) {
          this.$toast(res.msg || 'Unauthorized');
          this.$router.push({ path: '/Login' });
        } else {
          this.$toast(res.msg || 'Update failed');
        }
        this.isLoading = false;
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          const data = res.data;
          this.formData = {
            name: data.name || '',
            phone: data.phone || '',
            email: data.email || '',
            birthday: data.birthday || ''
          };
        } else if (res.code === 401) {
          this.$toast(res.msg);
          this.$router.push({ path: '/Login' });
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang="less" scoped>
.infomation-page {
  min-height: 100vh;
  background: #000;
  color: #f5f5f5;
  padding-bottom: 80px;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header-back {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 36px;
  color: #fff;
}

.header-title {
  flex: 1;
  text-align: center;
  font-size: 30px;
  font-weight: 700;
  margin: 0;
}

.header-placeholder {
  width: 40px;
}

/* 表单容器 */
.form-container {
  padding: 20px 16px;
}

.form-group {
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 28px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 8px;
}

.form-input {
  padding: 12px 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  background: #fff;
  color: #000;
  font-size: 28px;
  outline: none;
  transition: all 0.3s;
}

/* 提交按钮 */
.submit-btn {
  width: 100%;
  padding: 14px 16px;
  margin-top: 30px;
  background: #22cc61;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 28px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s;

  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}
</style>
